// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-io {
  width: 50%;
}

.view-io .view-io-title-content {
  color: #000;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}

.view-io .ant-modal-header {
  padding: 1.37rem 1.87rem;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 67%);
  margin-bottom: 0px;
}

.view-io .ant-modal-content {
  padding: 0;
}

.view-io .ant-modal-close {
  display: none;
}

.view-io-download-div {
  border-radius: 0.3125rem;
  background: var(--Colors-Primary-500, #d2042d);
  display: flex;
  padding: 0rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.view-io-title {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.view-io .ant-modal-body {
  background: #f5f5f5;
  overflow-y: scroll;
  max-height: 48rem;
}

.view-io-main-content-div {
  padding: 1rem 2rem 2rem 2rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  background: #fff;
  margin: 1.37rem 1.87rem;
  border-top: 1.25rem solid var(--Colors-Primary-500, #d2042d);
  position: relative;
}

.tag-line {
  font-family: Roboto;
  content: "We make advertising easy!";
  /* position: absolute; */
  width: 100%;
  background: var(--Colors-Primary-500, #d2042d);
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 0.4rem 0;
  font-size: 1.2rem;
}
.view-io-text {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.3125rem;
}

.view-io-left-alignment {
  text-align: left;
}

.view-io-right-alignment {
  text-align: right;
}

.view-io-table {
  .ant-table-content {
    overflow-x: auto;
    overflow-y: auto;
  }
  .ant-table-pagination {
    display: none !important;
  }
}

.view-io-table .ant-table-thead > tr > th {
  text-align: left !important;
}

.view-io-table .ant-table-cell {
  font-family: Roboto;
  padding: 5px 5px !important;
  font-size: 13px !important;
}

.view-offer-individual-table thead {
  display: none;
}

.view-io-terms {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3125rem;
}

.hide-bottom-text::after {
  margin-bottom: 1rem;
  display: none !important;
}

.hide-top-border {
  border-top: none !important;
}

.view-io-signature {
  height: 2rem;
  background-color: white !important;
  font-size: 1rem;
  border-radius: 0;
  border: 1px solid white !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  border-radius: 0 !important;
}

.io-container-sub-div {
  margin-top: 1rem;
  justify-content: space-between;
  flex-flow: nowrap;
}

.io-logo-css {
  width: 11.19238rem;
  height: 2.9375rem;
}

.io-col-sub-div {
  display: flex;
  flex-direction: column;
}

.io-campaign-details-row {
  margin-top: 2.7rem;
  justify-content: space-between;
  flex-flow: nowrap;
}

.io-campaign-details-row-text {
  font-family: Roboto;
  font-size: 19px;
  font-weight: 700;
}

.common-css {
  display: flex;
  justify-content: center;
}

.io-terms-row {
  margin-top: 1.7rem;
  justify-content: space-between;
  flex-flow: nowrap;
  border: 1px solid black;
}

.io-terms-row .price-section {
  display: flex;
  justify-content: space-between;
  gap: 4rem;
}
.io-address-div {
  margin-top: 1.7rem;
  justify-content: space-between;
  flex-flow: nowrap;
  border: 1px solid black;
}

.io-common-div-css {
  padding: 0.3rem;
  display: flex;
}

.io-save-button-css {
  color: white;
  background-color: var(--Colors-Primary-500, #d2042d);
  width: 5rem;
}

.io-divider-css {
  border: 10px solid #e0e0e0;
  border-radius: 5px;
}

.io-product-details-title {
  font-family: Roboto;
  font-size: 19px;
  font-weight: 700;
  text-align: left;
  color: var(--Colors-Primary-500, #d2042d);
}

.io-image-display-col {
  display: flex;
  align-items: center;
  width: 50%;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}

.io-comments-css {
  font-family: Roboto;
  border: 1px solid #dee2e6;
  padding: 0.5rem;
}

.io-billing-css {
  gap: 3rem;
  padding-bottom: 1rem;
}

.io-billing-text-css {
  font-family: Roboto;
  padding-bottom: 0.5rem;
  padding-top: 1rem;
}

.io-footer-text {
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 600;
}

.io-sponser-text-css {
  font-family: Roboto;
  text-align: center;
  font-size: 19px;
  font-weight: 700;
  color: #007bff;
}

.io-footer-bottom-css {
  margin-top: 2.7rem;
  margin-bottom: 2.7rem;
}

.quote-impressions-div {
  border: 1px solid black;
  justify-content: space-around;
  align-items: center;
}

.view-io-terms-input-div {
  display: flex;
  align-items: center;
}

.quote-impressions-col {
  font-weight: 500;
  color: var(--Colors-Primary-500, #d2042d);
}

.quote-divider {
  border: 10px solid #e0e0e0;
  border-radius: 5px;
}
.io-table-container.set-scroll-table .view-io-table {
  max-height: 400px !important;
  max-height: 400px !important;
  overflow-y: scroll !important;
}

.io-table-container.set-scroll-table::-webkit-scrollbar {
  width: 6px !important;
}
.io-table-container.set-scroll-table::-webkit-scrollbar-track {
  background: transparent !important;
}

/* Scrollbar thumb */
.io-table-container.set-scroll-table::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
}
.styling-hover-link {
  cursor: pointer;
}
.styling-hover-link {
  color: #007bff !important;
}
.io-request-btn {
  color: #000 !important;
  height: 30px !important;
  padding: 0.5rem 1rem !important;
}
.hold-status-in-progress {
  background: #fff8e8 !important;
  border: 1px solid #ffd591 !important;
  color: #fa8c16 !important;
}
.hold-status-in-progress:hover {
  background: #fff8e8 !important;
  border: 1px solid #ffd591 !important;
  color: #fa8c16 !important;
}
.hold-status-approved {
  background: #f6ffed !important;
  border: 1px solid #b7eb8f !important;
  color: #52c41a !important;
}
.hold-status-approved:hover {
  background: #f6ffed !important;
  border: 1px solid #b7eb8f !important;
  color: #52c41a !important;
}
.hold-status-rejected {
  background: #fff2f0 !important;
  border: 1px solid #ffccc7 !important;
  color: #ff4d4f !important;
}
.hold-status-rejected:hover {
  background: #fff2f0 !important;
  border: 1px solid #ffccc7 !important;
  color: #ff4d4f !important;
}
.product-request-hold-modal {
  width: 35% !important;
}

.payment-terms-table {
  border-collapse: collapse;
  width: 260px;
  margin-top: 5px;
}

.payment-terms-table td {
  border: 1px solid #000;
  padding: 4px 8px;
  font-size: 10px;
  text-align: center;
  font-family: Roboto;
}

.payment-terms-table td:last-child {
  text-align: right;
}

.price-section-first-div{
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 768px) {
  .view-io {
    width: 95% !important;
  }
  .io-header-row {
    margin-top: 27px;
    margin-bottom: 16px;
  }
  .view-io .view-io-title-content {
    font-size: var(--Font-Font-Size-h5, 1rem);
  }

  .view-io-main-content-div {
    margin: 1.37rem 1rem;
    padding: 0.5rem 1.5rem 1rem 1.5rem;
  }

  .view-io-download-div {
    padding: 0rem 0.5rem;
  }
  .view-io-main-content-div {
    border-top: 0.75rem solid var(--Colors-Primary-500, #d2042d);
  }
  .io-logo-css {
    width: 72px;
    height: 19px;
  }
  .io-col-sub-div {
    display: inline-block;
  }
  .io-campaign-details-row-text {
    font-size: 10px;
    font-weight: 500;
  }
  .view-io-table {
    margin-top: 17px;
    margin-bottom: 20px;
  }
  .terms-header,
  .io-address-header,
  .to-buyer {
    font-size: 14px;
    font-weight: 700;
  }
  .product-request-hold-modal {
    width: 90% !important;
  }
  .terms-text {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
  }
  .terms-row .terms-label {
    font-size: 14px;
    font-weight: 700;
  }
  .io-address-section {
    margin-top: 24.2px;
  }
  .io-address-header {
    margin-bottom: 11px;
  }
  .to-buyer {
    margin-bottom: 8px;
  }
  .io-address-section .help-text {
    color: #4a5565;
    font-size: 12px;
    font-weight: 400px;
    margin-bottom: 28px;
  }
  .io-address-section .buyer-details,
  .io-address-section .amp-details {
    background: #f9fafb;
  }
  .io-address-section .amp-details {
    margin-top: 20px;
  }
  .io-sign-mobile-card {
    margin-top: 24px;
  }
  .io-sign-mobile-card .sign-io {
    font-size: 16px;
    font-weight: 400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/io/CampaignDetailsIO.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,WAAW;EACX,8CAA8C;EAC9C,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,yCAAyC;EAC3C;;EAEA;IACE,oBAAoB;IACpB,kCAAkC;EACpC;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;;IAGE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".view-io {\n  width: 50%;\n}\n\n.view-io .view-io-title-content {\n  color: #000;\n  font-family: Montserrat;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n\n.view-io .ant-modal-header {\n  padding: 1.37rem 1.87rem;\n  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 67%);\n  margin-bottom: 0px;\n}\n\n.view-io .ant-modal-content {\n  padding: 0;\n}\n\n.view-io .ant-modal-close {\n  display: none;\n}\n\n.view-io-download-div {\n  border-radius: 0.3125rem;\n  background: var(--Colors-Primary-500, #d2042d);\n  display: flex;\n  padding: 0rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.view-io-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n}\n\n.view-io .ant-modal-body {\n  background: #f5f5f5;\n  overflow-y: scroll;\n  max-height: 48rem;\n}\n\n.view-io-main-content-div {\n  padding: 1rem 2rem 2rem 2rem;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  background: #fff;\n  margin: 1.37rem 1.87rem;\n  border-top: 1.25rem solid var(--Colors-Primary-500, #d2042d);\n  position: relative;\n}\n\n.tag-line {\n  font-family: Roboto;\n  content: \"We make advertising easy!\";\n  /* position: absolute; */\n  width: 100%;\n  background: var(--Colors-Primary-500, #d2042d);\n  color: #fff;\n  font-weight: bold;\n  text-align: center;\n  padding: 0.4rem 0;\n  font-size: 1.2rem;\n}\n.view-io-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.3125rem;\n}\n\n.view-io-left-alignment {\n  text-align: left;\n}\n\n.view-io-right-alignment {\n  text-align: right;\n}\n\n.view-io-table {\n  .ant-table-content {\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n  .ant-table-pagination {\n    display: none !important;\n  }\n}\n\n.view-io-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n\n.view-io-table .ant-table-cell {\n  font-family: Roboto;\n  padding: 5px 5px !important;\n  font-size: 13px !important;\n}\n\n.view-offer-individual-table thead {\n  display: none;\n}\n\n.view-io-terms {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.3125rem;\n}\n\n.hide-bottom-text::after {\n  margin-bottom: 1rem;\n  display: none !important;\n}\n\n.hide-top-border {\n  border-top: none !important;\n}\n\n.view-io-signature {\n  height: 2rem;\n  background-color: white !important;\n  font-size: 1rem;\n  border-radius: 0;\n  border: 1px solid white !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  border-radius: 0 !important;\n}\n\n.io-container-sub-div {\n  margin-top: 1rem;\n  justify-content: space-between;\n  flex-flow: nowrap;\n}\n\n.io-logo-css {\n  width: 11.19238rem;\n  height: 2.9375rem;\n}\n\n.io-col-sub-div {\n  display: flex;\n  flex-direction: column;\n}\n\n.io-campaign-details-row {\n  margin-top: 2.7rem;\n  justify-content: space-between;\n  flex-flow: nowrap;\n}\n\n.io-campaign-details-row-text {\n  font-family: Roboto;\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.common-css {\n  display: flex;\n  justify-content: center;\n}\n\n.io-terms-row {\n  margin-top: 1.7rem;\n  justify-content: space-between;\n  flex-flow: nowrap;\n  border: 1px solid black;\n}\n\n.io-terms-row .price-section {\n  display: flex;\n  justify-content: space-between;\n  gap: 4rem;\n}\n.io-address-div {\n  margin-top: 1.7rem;\n  justify-content: space-between;\n  flex-flow: nowrap;\n  border: 1px solid black;\n}\n\n.io-common-div-css {\n  padding: 0.3rem;\n  display: flex;\n}\n\n.io-save-button-css {\n  color: white;\n  background-color: var(--Colors-Primary-500, #d2042d);\n  width: 5rem;\n}\n\n.io-divider-css {\n  border: 10px solid #e0e0e0;\n  border-radius: 5px;\n}\n\n.io-product-details-title {\n  font-family: Roboto;\n  font-size: 19px;\n  font-weight: 700;\n  text-align: left;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n\n.io-image-display-col {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.io-comments-css {\n  font-family: Roboto;\n  border: 1px solid #dee2e6;\n  padding: 0.5rem;\n}\n\n.io-billing-css {\n  gap: 3rem;\n  padding-bottom: 1rem;\n}\n\n.io-billing-text-css {\n  font-family: Roboto;\n  padding-bottom: 0.5rem;\n  padding-top: 1rem;\n}\n\n.io-footer-text {\n  font-family: Roboto;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.io-sponser-text-css {\n  font-family: Roboto;\n  text-align: center;\n  font-size: 19px;\n  font-weight: 700;\n  color: #007bff;\n}\n\n.io-footer-bottom-css {\n  margin-top: 2.7rem;\n  margin-bottom: 2.7rem;\n}\n\n.quote-impressions-div {\n  border: 1px solid black;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.view-io-terms-input-div {\n  display: flex;\n  align-items: center;\n}\n\n.quote-impressions-col {\n  font-weight: 500;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n\n.quote-divider {\n  border: 10px solid #e0e0e0;\n  border-radius: 5px;\n}\n.io-table-container.set-scroll-table .view-io-table {\n  max-height: 400px !important;\n  max-height: 400px !important;\n  overflow-y: scroll !important;\n}\n\n.io-table-container.set-scroll-table::-webkit-scrollbar {\n  width: 6px !important;\n}\n.io-table-container.set-scroll-table::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n\n/* Scrollbar thumb */\n.io-table-container.set-scroll-table::-webkit-scrollbar-thumb {\n  border-radius: 10px !important;\n}\n.styling-hover-link {\n  cursor: pointer;\n}\n.styling-hover-link {\n  color: #007bff !important;\n}\n.io-request-btn {\n  color: #000 !important;\n  height: 30px !important;\n  padding: 0.5rem 1rem !important;\n}\n.hold-status-in-progress {\n  background: #fff8e8 !important;\n  border: 1px solid #ffd591 !important;\n  color: #fa8c16 !important;\n}\n.hold-status-in-progress:hover {\n  background: #fff8e8 !important;\n  border: 1px solid #ffd591 !important;\n  color: #fa8c16 !important;\n}\n.hold-status-approved {\n  background: #f6ffed !important;\n  border: 1px solid #b7eb8f !important;\n  color: #52c41a !important;\n}\n.hold-status-approved:hover {\n  background: #f6ffed !important;\n  border: 1px solid #b7eb8f !important;\n  color: #52c41a !important;\n}\n.hold-status-rejected {\n  background: #fff2f0 !important;\n  border: 1px solid #ffccc7 !important;\n  color: #ff4d4f !important;\n}\n.hold-status-rejected:hover {\n  background: #fff2f0 !important;\n  border: 1px solid #ffccc7 !important;\n  color: #ff4d4f !important;\n}\n.product-request-hold-modal {\n  width: 35% !important;\n}\n\n.payment-terms-table {\n  border-collapse: collapse;\n  width: 260px;\n  margin-top: 5px;\n}\n\n.payment-terms-table td {\n  border: 1px solid #000;\n  padding: 4px 8px;\n  font-size: 10px;\n  text-align: center;\n  font-family: Roboto;\n}\n\n.payment-terms-table td:last-child {\n  text-align: right;\n}\n\n.price-section-first-div{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n@media (max-width: 768px) {\n  .view-io {\n    width: 95% !important;\n  }\n  .io-header-row {\n    margin-top: 27px;\n    margin-bottom: 16px;\n  }\n  .view-io .view-io-title-content {\n    font-size: var(--Font-Font-Size-h5, 1rem);\n  }\n\n  .view-io-main-content-div {\n    margin: 1.37rem 1rem;\n    padding: 0.5rem 1.5rem 1rem 1.5rem;\n  }\n\n  .view-io-download-div {\n    padding: 0rem 0.5rem;\n  }\n  .view-io-main-content-div {\n    border-top: 0.75rem solid var(--Colors-Primary-500, #d2042d);\n  }\n  .io-logo-css {\n    width: 72px;\n    height: 19px;\n  }\n  .io-col-sub-div {\n    display: inline-block;\n  }\n  .io-campaign-details-row-text {\n    font-size: 10px;\n    font-weight: 500;\n  }\n  .view-io-table {\n    margin-top: 17px;\n    margin-bottom: 20px;\n  }\n  .terms-header,\n  .io-address-header,\n  .to-buyer {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  .product-request-hold-modal {\n    width: 90% !important;\n  }\n  .terms-text {\n    font-size: 14px;\n    font-weight: 400;\n    color: #0a0a0a;\n  }\n  .terms-row .terms-label {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  .io-address-section {\n    margin-top: 24.2px;\n  }\n  .io-address-header {\n    margin-bottom: 11px;\n  }\n  .to-buyer {\n    margin-bottom: 8px;\n  }\n  .io-address-section .help-text {\n    color: #4a5565;\n    font-size: 12px;\n    font-weight: 400px;\n    margin-bottom: 28px;\n  }\n  .io-address-section .buyer-details,\n  .io-address-section .amp-details {\n    background: #f9fafb;\n  }\n  .io-address-section .amp-details {\n    margin-top: 20px;\n  }\n  .io-sign-mobile-card {\n    margin-top: 24px;\n  }\n  .io-sign-mobile-card .sign-io {\n    font-size: 16px;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
